import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {Button, Drawer, Form, InputNumber, message, Modal, Table, Typography} from 'antd';
import UseCollectionWorkProjectRecord, {ICollectionWorkProjectRecord} from '../../hooks/apis/useCollectionWorkProjectRecord';
import {useBoolean} from 'react-hanger';
import {UserType} from '../../hooks/apis/useUser';
import useAuth from '../../utils/AuthContext';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export interface RefreshRef {
  refresh: () => any;
}
// eslint-disable-next-line react/display-name
export const CollectionWorkProjectRecordList = forwardRef((props: {collectionWorkId?: number; onFinish?: () => any}, ref) => {
  const listHook = UseCollectionWorkProjectRecord.list();
  const removeHook = UseCollectionWorkProjectRecord.remove();
  const isRank = useBoolean(false);
  const auth = useAuth();
  const [selected, setSelected] = useState<ICollectionWorkProjectRecord>();
  function refresh() {
    listHook
      .request({
        collectionWorkId: props.collectionWorkId,
      })
      .then()
      .catch(CommonApiErrorHandler);
  }

  useEffect(() => {
    if (props.collectionWorkId) {
      refresh();
    }
  }, [props.collectionWorkId]);

  useImperativeHandle(ref, () => ({
    refresh,
  }));

  return (
    <div>
      <Table<ICollectionWorkProjectRecord> dataSource={listHook.data} rowKey={'id'} size={'small'}>
        <Table.Column<ICollectionWorkProjectRecord> title="参评项目" width={100} dataIndex={['collectionWorkProject', 'name']} />
        <Table.Column<ICollectionWorkProjectRecord> title="作品名称" width={100} dataIndex="name" />
        <Table.Column<ICollectionWorkProjectRecord>
          title="文件"
          width={150}
          dataIndex={['fileRecord', 'name']}
          render={(_, row) => <Typography.Link href={row.fileRecord?.url}>{_}</Typography.Link>}
        />
        <Table.Column<ICollectionWorkProjectRecord>
          width={90}
          title="文件大小"
          dataIndex={['fileRecord', 'sizeMb']}
          render={(_, row) => <Typography.Text>{_.toFixed(2)} Mb</Typography.Text>}
        />
        {/*<Table.Column<ICollectionWorkProjectRecord> title="上传时间" dataIndex={['fileRecord', 'createdTime']} width={120} />*/}
        <Table.Column<ICollectionWorkProjectRecord>
          width={100}
          title="操作"
          render={(_, row) => (
            <Button
              type={'link'}
              onClick={() => {
                Modal.confirm({
                  title: '确定要删除吗？',
                  okText: '确认',
                  cancelText: '取消',
                  onOk: () => {
                    removeHook
                      .request({
                        id: row.id,
                      })
                      .then(() => {
                        message.success('删除成功');
                        refresh();
                        props.onFinish && props.onFinish();
                      })
                      .catch(CommonApiErrorHandler);
                  },
                });
              }}>
              删除
            </Button>
          )}
        />
      </Table>
    </div>
  );
});
export default CollectionWorkProjectRecordList;
